<template>
  <el-dialog
    :title="title"
    :visible.sync="innerVisible"
    :width="width"
    :top="top"
    custom-class="crm-form-dialog"
    :append-to-body="appendToBody"
    :destroy-on-close="destroyOnClose"
    :close-on-click-modal="false"
    :close-on-press-escape="false"
    @open="$emit('open')"
    @closed="$emit('closed')"
  >
    <slot />
    <div v-if="$slots.footer" slot="footer" class="dialog-footer">
      <slot name="footer" />
    </div>
  </el-dialog>
</template>

<script>
export default {
  name: 'FormDialog',
  props: {
    visible: { type: Boolean, default: false },
    title: { type: String, default: '' },
    width: { type: String, default: '520px' },
    top: { type: String, default: '0' },
    appendToBody: { type: Boolean, default: true },
    destroyOnClose: { type: Boolean, default: false }
  },
  computed: {
    innerVisible: {
      get() {
        return this.visible
      },
      set(v) {
        this.$emit('update:visible', v)
      }
    }
  }
}
</script>
